import {Chip, Divider, Stack, Tooltip, Typography} from "@mui/material";
import {findFlag} from "../Results";
import moment from "moment";

const SRPSKI_DANI = ["nedelja", "ponedeljak", "utorak", "sreda", "četvrtak", "petak", "subota"];

export default function TripCardHeader({data, hovered, index, hoveredRef}) {
    const flagDep = findFlag(data?.depCountryName);
    const flagArr = findFlag(data?.arrCountryName);

    const depMoment = moment.utc(data?.departureTripTime);
    const depDateLabel = depMoment.isValid()
        ? `${depMoment.format("DD.MM.YYYY.")} · ${SRPSKI_DANI[depMoment.day()]}`
        : "";

    const fullText = (data?.printText || data?.lineName || '').toUpperCase();
    const maxCharsPerLine = 40;
    const maxLines = 2;

    const lines = [];
    for (let i = 0; i < maxLines; i++) {
        const start = i * maxCharsPerLine;
        const part = fullText.slice(start, start + maxCharsPerLine);
        if (part) lines.push(part);
    }

    const isTruncated = fullText.length > maxCharsPerLine * maxLines;

    const isCalem = data?.linkId !== null

    return (
        <Stack
            sx={{
                position: "relative",
            }}
            ref={hovered === index ? hoveredRef : null}
            direction="row"
            spacing={2}
            alignItems="center"
        >
            {data.externalSale === true &&
                <Stack sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    py: 0.5,
                    backgroundColor: "primary.light",
                    width: "100%",
                    overflow: "hidden",
                    pointerEvents: 'none',
                    zIndex: 999,
                    "-webkit-transition": "width 1s ease, height 1s ease",
                    "-moz-transition": "width 1s ease, height 1s ease",
                    "-o-transition": "width 1s ease, height 1s ease",
                    "transition": "width 0.4s ease, height 0.4s ease",
                    "-ms-transform": "translateX(-48%) translateY(0%) rotate(-45deg)",
                    "-webkit-transform": "translateX(-48%) translateY(0%) rotate(-45deg)",
                    "transform": "translateX(-48%) translateY(0%) rotate(-45deg)",
                }}>
                    <Typography textTransform="uppercase" textAlign="center">
                        {data.externalPartner}
                    </Typography>
                </Stack>}
            {/* Početna stanica */}
            <Stack sx={{alignItems: "left", justifyContent: "center", width: 150}}>
                <Typography variant="h3" sx={{fontWeight: 700, color: "#6DABE4"}}>
                    {moment.utc(data.departureTripTime).format("HH:mm")}
                </Typography>
                <Typography sx={{fontSize: 12, letterSpacing: 1.2}} variant="subtitle1">
                    {moment.utc(data.departureTripTime).format("DD.MM.YYYY")}
                </Typography>
                <Typography sx={{fontSize: 16, letterSpacing: 1.2}} variant="subtitle1">
                    <Tooltip title={data.depStationName || ''}>
                        <Typography sx={{fontSize: 16, letterSpacing: 1.2}} variant="subtitle1">
                            {data.depStationName}
                        </Typography>
                    </Tooltip>
                </Typography>
                <Typography sx={{letterSpacing: 1.2}} variant="caption">
                    ({data.depCountryName})
                </Typography>
            </Stack>

            {/*<Image src="/assets/icons/home/bus-outbound.svg" disabledEffect alt="out" sx={{height: 64}}/>*/}

            {/* Zastava i šifra stanice */}
            {/*<Stack direction="column" alignItems="center">*/}
            {/*    <Typography variant="subtitle1" sx={{fontSize: 18, color: "text.disabled"}}>*/}
            {/*        {data?.depStationName?.toUpperCase()?.slice(0, 3)}*/}
            {/*    </Typography>*/}
            {/*    <Divider orientation="vertical" sx={{width: "100%", borderRadius: 5, borderWidth: 3}}/>*/}
            {/*    {flagDep ? (*/}
            {/*        <Image src={flagDep} disabledEffect alt="flag" sx={{height: 30}}/>*/}
            {/*    ) : (*/}
            {/*        <Typography variant="subtitle2" sx={{color: "text.disabled"}}>*/}
            {/*            ?*/}
            {/*        </Typography>*/}
            {/*    )}*/}
            {/*</Stack>*/}

            {/* Informacije o firmi i liniji */}
            <Stack sx={{flex: 1}}>
                {depDateLabel && (
                    <Chip
                        size="small"
                        color="info"
                        label={depDateLabel}
                        sx={{alignSelf: "center", mb: 0.75, fontWeight: 700, letterSpacing: 0.5, textTransform: "capitalize"}}
                    />
                )}
                {data?.issuedFor?.name ? (
                    <Typography variant="h6" textAlign="center" sx={{color: "success.main", letterSpacing: 1.2}}>
                        {data.issuedFor.name.toUpperCase()}
                    </Typography>
                ) : (
                    <Typography variant="h6" textAlign="center" sx={{color: "success.main", letterSpacing: 1.2}}>
                        {data.operatorName?.toUpperCase()}
                    </Typography>
                )}
                <Divider textAlign="center">
                    <Typography variant="subtitle2" sx={{color: "text.disabled"}}>
                        {data?.tripTime}
                    </Typography>
                </Divider>

                <Typography
                    variant="subtitle2"
                    textAlign="center"
                    sx={{fontStyle: 'italic', color: 'success.info', whiteSpace: 'pre-line'}}
                >
                    LINIJA:{'\n'}
                    {lines.join('\n')}
                    {isTruncated ? '...' : ''}
                </Typography>
                <Typography  variant="caption"
                             textAlign="center"
                             sx={{fontStyle: 'italic', fontWeight: "bold", color: 'success.info'}}>{isCalem && "(KALEM POLAZAK)"}</Typography>

            </Stack>

            {/* Dolazna stanica */}
            {/*<Stack direction="column" alignItems="center">*/}
            {/*    <Typography variant="subtitle1" sx={{color: "text.disabled"}}>*/}
            {/*        {data.arrStationName.slice(0, 3).toUpperCase()}*/}
            {/*    </Typography>*/}
            {/*    <Divider orientation="vertical" sx={{width: "100%", borderRadius: 5, borderWidth: 3}}/>*/}
            {/*    {flagArr ? (*/}
            {/*        <Image src={flagArr} disabledEffect alt="flag" sx={{height: 30}}/>*/}
            {/*    ) : (*/}
            {/*        <Typography variant="subtitle2" sx={{color: "text.disabled"}}>*/}
            {/*            ?*/}
            {/*        </Typography>*/}
            {/*    )}*/}
            {/*</Stack>*/}

            {/*<Image src="/assets/icons/home/bus-inbound.svg" disabledEffect alt="in" sx={{height: 64}}/>*/}

            <Stack sx={{width: 150}}>
                <Typography textAlign="right" variant="h3" sx={{fontWeight: 700, color: "#6DABE4"}}>
                    {moment(data?.arrTripTime).format("HH:mm")}
                </Typography>
                <Typography textAlign="right" sx={{fontSize: 12, letterSpacing: 1.2}} variant="subtitle1">
                    {moment.utc(data.arrTripTime).format("DD.MM.YYYY")}
                </Typography>
                <Tooltip title={data.arrStationName || ''}>
                    <Typography textAlign="right" sx={{fontSize: 16, letterSpacing: 1.2}} variant="subtitle1">
                        {data.arrStationName}
                    </Typography>
                </Tooltip>
                <Typography textAlign="right" sx={{letterSpacing: 1.2}} variant="caption">
                    ({data.arrCountryName})
                </Typography>
            </Stack>
        </Stack>
    );
}
